/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import {declareLinkedEntity} from '../fw/MetaDataHelper.ts';
import * as Permission from "../util/Permission";

export default declareLinkedEntity({
    entity: "organisationAddons",
    graphQL: "OrganisationAddon",
    name: "Organisation Addon",
    storageType: 'central',
    defaultOrder: ['name', 'type'],
    parentRelation: "organisationAddons",
    writePermission: [
        Permission.PERM_EDIT_ORGANISATION,
    ],
    defaultTitle: (data) => {
        if (data['name']) {
            return data['name'];
        }
    },
    fields: (types) => { return {
        id: {
            name: "Organisation Addon ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (organisation) => {
                return organisation['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        externalId: {
            name: "External ID",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        type: {
            name: "Type",
            type: "string",
            defaultValue: ""
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: ""
        },
        enabled: {
            name: "Enabled",
            type: "boolean",
            defaultValue: true,
            filterable: true,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        options: {
            name: "Options",
            type: "object",
            defaultValue: {},
        }
    }; },
    relations: (types) => { return {
        channelSystemPlugins: {
            type: 'oneToMany',
            to: types['channels'],
            hasPaging: false,
            controllerFn: 'getChannelSystemPlugins',
        },
        channelAllPlugins: {
            type: 'oneToMany',
            to: types['channels'],
            hasPaging: false,
            controllerFn: 'getAllChannelPlugins',
        },
        channelCachingPlugins: {
            type: 'oneToMany',
            to: types['channels'],
            hasPaging: false,
            controllerFn: 'getCachingChannelPlugins',
        },
    }; }
});
